import { useState } from 'react';
import { Link } from 'react-router-dom';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/db8do21rh5tg6socjt50';

const stats = [
  { label: '收录影片', value: '12,000+' },
  { label: '影视资讯', value: '3,600+' },
  { label: '策划专题', value: '180+' },
  { label: '日活影迷', value: '56,000+' },
];

const values = [
  { icon: 'ri-vip-diamond-line', title: '专注高清', desc: '坚持收录高清画质的电影资源，让每一次观影都有清晰、舒适的体验。' },
  { icon: 'ri-flashlight-line', title: '及时更新', desc: '紧跟院线与行业动态，最新影片与资讯第一时间同步，不错过任何热点。' },
  { icon: 'ri-shield-check-line', title: '干净纯粹', desc: '拒绝繁琐注册与弹窗打扰，打开就能找片、看片，专注内容本身。' },
  { icon: 'ri-heart-3-line', title: '为影迷而做', desc: '从选片、筛片到深度影评，我们真正站在影迷的角度思考每一个功能。' },
];

export default function About() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);

    const honeypot = String(fd.get('contact_alt') || '').trim();
    if (honeypot) {
      setStatus('success');
      setFormError('');
      form.reset();
      return;
    }

    const payload = new URLSearchParams();
    fd.forEach((value, key) => {
      if (key === 'contact_alt') return;
      const v = String(value).trim();
      if (v) payload.append(key, v);
    });

    try {
      setStatus('submitting');
      const response = await fetch(SUBMIT_ADDR, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后重试';
      const isOk = response.ok && parsed?.code === 'OK';
      const isSpam = typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam');

      if (isOk && !isSpam) {
        setStatus('success');
        setFormError('');
        form.reset();
      } else {
        setStatus('error');
        setFormError(serverMsg);
      }
    } catch {
      setStatus('error');
      setFormError('网络连接异常，请稍后重试。');
    }
  };

  return (
    <div className="w-full bg-background-50">
      <section className="relative w-full h-[280px] md:h-[360px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Stylized%20cinematic%20abstract%20banner%20of%20a%20dark%20movie%20theater%20with%20projector%20light%20beam%20and%20warm%20orange%20glow%2C%20midnight-blue%20and%20charcoal%20tones%2C%20film%20grain%2C%20high%20detail%2C%20atmospheric%20wide%20composition&width=1600&height=600&seq=about-hero-band&orientation=landscape"
          alt="午夜电影网 品牌氛围"
          title="午夜电影网 - 关于我们"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/75 to-background-50/40"></div>
        <div className="absolute inset-0 flex items-center">
          <div className="w-full px-4 md:px-8">
            <div className="max-w-screen mx-auto">
              <nav className="text-xs md:text-sm text-foreground-600 mb-4 flex items-center gap-1.5">
                <Link to="/" className="hover:text-primary-400 transition-colors">首页</Link>
                <i className="ri-arrow-right-s-line"></i>
                <span className="text-foreground-800">关于我们</span>
              </nav>
              <h1 className="text-2xl md:text-4xl font-black text-foreground-950 mb-2">关于午夜电影网</h1>
              <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
                一个为影迷而生的高清电影与影视资讯平台。
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="max-w-screen mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mb-14">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-4">我们是谁</h2>
              <p className="text-sm md:text-base text-foreground-700 leading-loose mb-4">
                午夜电影网成立于一群资深影迷之手。我们厌倦了那些充斥着弹窗、注册与广告的观影网站，于是决定亲手做一个干净、纯粹、只专注于内容的平台。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-loose">
                在这里，你可以按类型、年份、地区与评分自由筛选影片，浏览最新的行业资讯与深度影评，也能通过编辑策划的专题合集，发现那些原本可能错过的佳作。我们希望午夜电影网，能成为每一个深夜想看电影的人，最先打开的那一个。
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {stats.map((s) => (
                <div key={s.label} className="bg-background-100 border border-background-300/50 rounded-lg p-5 text-center">
                  <p className="font-label text-3xl md:text-4xl text-primary-500 mb-1">{s.value}</p>
                  <p className="text-xs md:text-sm text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-6">我们的坚持</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {values.map((v) => (
                <div key={v.title} className="bg-background-100 border border-background-300/50 rounded-lg p-5">
                  <span className="w-11 h-11 rounded-full bg-accent-800 flex items-center justify-center mb-4">
                    <i className={`${v.icon} text-xl text-primary-400`}></i>
                  </span>
                  <h3 className="text-base font-bold text-foreground-950 mb-2">{v.title}</h3>
                  <p className="text-sm text-foreground-700 leading-relaxed">{v.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.2fr] gap-10 bg-background-100 border border-background-300/50 rounded-lg p-6 md:p-8">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-4">联系我们</h2>
              <p className="text-sm text-foreground-700 leading-relaxed mb-6">
                无论你是想推荐影片、反馈问题，还是希望与我们合作，都欢迎给我们留言。我们会认真阅读每一条消息。
              </p>
              <ul className="space-y-4 text-sm">
                <li className="flex items-center gap-3 text-foreground-700">
                  <span className="w-9 h-9 rounded-full bg-accent-800 flex items-center justify-center">
                    <i className="ri-mail-line text-primary-400"></i>
                  </span>
                  contact@midnight-movie.example.com
                </li>
                <li className="flex items-center gap-3 text-foreground-700">
                  <span className="w-9 h-9 rounded-full bg-accent-800 flex items-center justify-center">
                    <i className="ri-map-pin-line text-primary-400"></i>
                  </span>
                  北京市朝阳区光影大道 88 号
                </li>
                <li className="flex items-center gap-3 text-foreground-700">
                  <span className="w-9 h-9 rounded-full bg-accent-800 flex items-center justify-center">
                    <i className="ri-time-line text-primary-400"></i>
                  </span>
                  周一至周五 10:00 - 19:00
                </li>
              </ul>
            </div>

            <div>
              {status === 'success' ? (
                <div className="h-full flex flex-col items-center justify-center text-center py-10">
                  <div className="w-14 h-14 rounded-full bg-primary-500/15 flex items-center justify-center mb-4">
                    <i className="ri-check-line text-3xl text-primary-500"></i>
                  </div>
                  <h3 className="text-lg font-bold text-foreground-950 mb-2">留言提交成功</h3>
                  <p className="text-sm text-foreground-600 mb-6">感谢你的反馈，我们会尽快查看并与你联系。</p>
                  <button
                    type="button"
                    onClick={() => setStatus('idle')}
                    className="px-5 py-2.5 rounded-md bg-background-200/70 hover:bg-background-300/70 text-foreground-900 text-sm transition-colors whitespace-nowrap cursor-pointer"
                  >
                    再写一条
                  </button>
                </div>
              ) : (
                <form data-readdy-form id="contact-form" onSubmit={handleSubmit} className="space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="contact-name" className="block text-xs font-medium text-foreground-700 mb-1.5">您的称呼</label>
                      <input
                        id="contact-name"
                        name="name"
                        type="text"
                        required
                        maxLength={40}
                        placeholder="请输入称呼"
                        className="w-full px-3 py-2.5 rounded-md bg-background-50 border border-background-300/60 text-sm text-foreground-900 placeholder:text-foreground-500 outline-none focus:border-primary-400 transition-colors"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-xs font-medium text-foreground-700 mb-1.5">邮箱</label>
                      <input
                        id="contact-email"
                        name="email"
                        type="email"
                        required
                        maxLength={60}
                        placeholder="you@example.com"
                        className="w-full px-3 py-2.5 rounded-md bg-background-50 border border-background-300/60 text-sm text-foreground-900 placeholder:text-foreground-500 outline-none focus:border-primary-400 transition-colors"
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="contact-subject" className="block text-xs font-medium text-foreground-700 mb-1.5">主题</label>
                    <input
                      id="contact-subject"
                      name="subject"
                      type="text"
                      maxLength={60}
                      placeholder="例如：影片推荐 / 内容反馈"
                      className="w-full px-3 py-2.5 rounded-md bg-background-50 border border-background-300/60 text-sm text-foreground-900 placeholder:text-foreground-500 outline-none focus:border-primary-400 transition-colors"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-xs font-medium text-foreground-700 mb-1.5">留言内容</label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      maxLength={500}
                      rows={5}
                      placeholder="请输入你的留言（最多 500 字）"
                      className="w-full px-3 py-2.5 rounded-md bg-background-50 border border-background-300/60 text-sm text-foreground-900 placeholder:text-foreground-500 outline-none focus:border-primary-400 transition-colors resize-none"
                    ></textarea>
                  </div>

                  <input
                    type="text"
                    name="contact_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="form-field-decoy"
                  />

                  {status === 'error' && (
                    <p className="text-sm text-primary-400">{formError}</p>
                  )}

                  <button
                    type="submit"
                    disabled={status === 'submitting'}
                    className="w-full py-3 rounded-md bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-background-50 text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {status === 'submitting' ? '提交中…' : '提交留言'}
                  </button>
                  <p className="text-xs text-foreground-600 text-center">本站为演示项目，留言将用于功能演示展示。</p>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}